module.exports = __webpack_public_path__ + "img/resumenModelo.410f2a02.svg";